<script type="text/javascript">
	import Button,{ Label } from '@smui/button';
	import Tab,{ Label as TabLabel } from '@smui/tab';
	import TabBar from '@smui/tab-bar';
	import Textfield from "@smui/textfield";
	import { writable } from "svelte/store";
	import AuthStore from "../../Auth/Store";
	import LngLatFormat from "../../Enums/LngLatFormat";
	import LoadState from "../../Enums/LoadState";
	import StringHelper from "../../Helpers/StringHelper";
	import MapStore from "../../Map/Store";
	import SpinnerButton from "../../UI/Admin/SpinnerButton.svelte";
	import ModalWindow from "../../UI/ModalWindow.svelte";
	import TextfieldWithButton from "../../UI/TextfieldWithButton/TextfieldWithButton.svelte";
	import "./MARMANs.scss";
	import MARMANsTable from "./MARMANsTable.svelte";
	import MARMANsStore from "./Store";
	
	let loadState = MARMANsStore.meta.loadState;
	let loaded = false;
	$: {
		loaded = $loadState === LoadState.LOADED;
	}

	let visible = MARMANsStore.meta.visible;
	MARMANsStore.meta.visible.subscribe((visible) => {
		if (visible
			// User.hasFeature(Feature.HURRICANES.VIEW)
			) {
			MARMANsStore.actions.init();
		}
	});

	let marmans = MARMANsStore.results.marmans;
	let lastUpdated = MARMANsStore.meta.lastUpdated;
	$: {
		$visible;
		$lastUpdated;
		MARMANsStore.actions.updateFeatureCollection();
		MARMANsStore.actions.updateVisibility();
	}

	let spatialQueryMarmans = MARMANsStore.spatialQuery.results.marmans;
	let spatialQueryLoadState = MARMANsStore.spatialQuery.meta.loadState;
	let spatialQueryError = MARMANsStore.spatialQuery.meta.error;


	$: {
		$lastUpdated;
		$marmans = $marmans;
		$spatialQueryMarmans = $spatialQueryMarmans;
	}

	let rawFilterString = MARMANsStore.filters.filterString;

	let hstyle = "font-weight:bold;margin-top:5px;margin-bottom:5px;";

	let applyPaste = (inputValue) => {
		// TODO:
	};
	let onFilterInput = (e) => {
		if (e.inputType === "insertFromPaste") {
			applyPaste(e.target.value);
		} else if (e.inputType === "insertText") {
			applyPaste(e.target.value);
		}
	};
	let onFilterKeyUp = (e) => {
		if (e.key === "Enter") {
			applyPaste(e.target.value);
		}
	};

	let tabs = ["List", "Query"];
	let activeTab = writable("List");

	let user = AuthStore.session.user;
	let lngLatReadable = writable($user.defaultLngLatStr);

</script>

{#if loaded}
	<ModalWindow
		title={`MARMANs`}
		hasCloseButton={true}
		hasBackground={false}
		resizable={true}
		draggable={true}
		fullscreen={false}
		padding={false}
		position="top-right"
		height="70%"
		bind:open={$visible} >

		<TabBar tabs={tabs} let:tab bind:active={$activeTab} class="border-shadow">
			<Tab tab={tab} minWidth><TabLabel>{tab}</TabLabel></Tab>
		</TabBar>

		<div class="content padding">

			{#if $activeTab === "List"}

				<Textfield fullwidth dense variant="filled" label="Filter MARMANs by name..."
					bind:value={$rawFilterString}
					on:input={onFilterInput}
					on:keyup={onFilterKeyUp} />

				<MARMANsTable
					marmans={$marmans}
					filterString={$rawFilterString}
					on:update={()=>{ $lastUpdated = Date.now(); }}
					/>

			{:else if $activeTab === "Query"}
				<h2>Point (lng, lat):</h2>
				<TextfieldWithButton
					bind:value={$lngLatReadable}
					disabled={false}
					buttonIcon="colorize"
					on:change={()=>{
						//updatePoint($lngLatReadable);
					}}
					on:keyup={(e) => {
						//updatePointEvent(e);
					}}
					on:buttonclick={(e) => {
						MapStore.helpers.startSingleLngLatPick((resultText)=>{
							$lngLatReadable = resultText;
						});
					}}
					/>
				{#if $spatialQueryLoadState === LoadState.LOADING}
					<SpinnerButton style="width:100%;margin-top:10px;"/>
				{:else}
					<Button color="secondary" variant="unelevated"
						style="width:100%;margin-top:10px;"
						on:click={()=>{
							let useLngLat = $lngLatReadable;
							if ($user.lngLatFormat === LngLatFormat.DMS) {
								useLngLat = StringHelper.formatDMSToDecimal($lngLatReadable);
							}
							const arr = useLngLat.split(", ");
							MARMANsStore.actions.spatialQuery(arr);
						}}>
					<Label>Submit</Label>
				</Button>
				{/if}

				{#if $spatialQueryLoadState === LoadState.LOADED}
					{#if $spatialQueryMarmans.length === 0}
						<div class='msgbox bg-info mt-10'>No results.</div>
					{:else}
						<MARMANsTable
							marmans={$spatialQueryMarmans}
							height="200"
							on:update={()=>{ $lastUpdated = Date.now(); }}
						/>
					{/if}
				{/if}
				{#if $spatialQueryError.length > 0}
					<div class='msgbox bg-error mt-10'>{$spatialQueryError}</div>
				{/if}

			{/if}


		</div>



	</ModalWindow>
{/if}
